import { useIntl } from 'react-intl';
import { formatMoney } from 'util/currency';
import { types as sdkTypes } from 'util/sdkLoader';
import css from './AddonPill.module.css';

const { Money } = sdkTypes;

const darkenColour = (hex, factor = 0.55) => {
  if (!hex || typeof hex !== 'string') return '#555555';
  const clean = hex.replace('#', '');
  if (clean.length !== 6) return '#555555';
  const r = Math.round(parseInt(clean.slice(0, 2), 16) * factor);
  const g = Math.round(parseInt(clean.slice(2, 4), 16) * factor);
  const b = Math.round(parseInt(clean.slice(4, 6), 16) * factor);
  return `rgb(${r}, ${g}, ${b})`;
};

/**
 * @param {{
 *   addon: { id?: string, name: string, colour?: string, amount?: string | number },
 *   currency?: string,
 *   checked?: boolean,
 *   onChange?: () => void,
 *   quantity?: number,
 *   size?: 'sm',
 * }} props
 */
const AddonPill = ({ addon, currency, checked, onChange, quantity, size }) => {
  const intl = useIntl();
  const amount = parseInt(addon.amount, 10);
  const formatted = currency && !isNaN(amount) ? formatMoney(intl, new Money(amount, currency)) : null;
  const isInteractive = typeof onChange === 'function';
  const sizeClass = size === 'sm' ? css.sm : null;

  const label = (
    <>
      {quantity != null && <span className={css.quantity}>{quantity} x</span>}
      <span>{addon.name}</span>
      {formatted && <span className={css.price}>{formatted}</span>}
    </>
  );

  if (isInteractive) {
    return (
      <button
        type="button"
        onClick={onChange}
        className={[sizeClass, checked ? css.pillChecked : css.pillUnchecked].filter(Boolean).join(' ')}
        style={{ backgroundColor: `${addon.colour}22`, color: darkenColour(addon.colour) }}
      >
        <span
          className={css.checkbox}
          style={checked ? { backgroundColor: darkenColour(addon.colour), borderColor: darkenColour(addon.colour) } : undefined}
        >
          {checked && <span className={css.checkmark} style={{ color: 'white' }}>✓</span>}
        </span>
        {label}
      </button>
    );
  }

  return (
    <span
      className={[sizeClass, css.pill].filter(Boolean).join(' ')}
      style={{
        backgroundColor: `${addon.colour}22`,
        borderColor: `${addon.colour}44`,
        color: darkenColour(addon.colour),
      }}
    >
      {label}
    </span>
  );
};

export default AddonPill;
